export const DRAFT = 0;
export const WAITING_APPROVAL = 1;
export const APPROVED = 2;
export const REJECTED = 3;

export function isDraft(id) {
    return DRAFT === id;
}

export function isApproved(paperState) {
    return APPROVED === paperState;
}

export function isRejected(id) {
    return REJECTED === id;
}

export function getTypeForId(id) {
    switch (id) {
        case DRAFT:
            return "Draft";
        case WAITING_APPROVAL:
            return "In aprobare";
        case REJECTED:
            return "Respins";
        case APPROVED:
            return "Aprobat";
        default:
            return "In aprobare";
    }
}